import { FormProvider, useForm } from 'react-hook-form'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import { useMutation } from '@apollo/client'
import {
  GET_ALL_USER_PERMISSIONS,
  GET_USERS,
  REGISTER_USE_FROM_LOGIN,
} from '../../graphql/Catalog/Users/user'
import { useContext, useState } from 'react'
import {
  validationSchemaRegisterUser,
} from '../Helpers/validatorCustomerForm'
import { yupResolver } from '@hookform/resolvers/yup'
import Box from '../Global/Box'
import InputController from '../Global/InputController'
import { AUTH_USER, DECRYPT_TOKEN } from '../../graphql/Auth/auth'
import { AuthContext } from '../../Auth/AuthContext'
import { types } from '../../Types/types'
import Logo from './../../Assets/Images/logo-02.png'
import MigrantsHeader from '../DashboardMigrants/components/MigrantsHeader'
import MigrantsFooter from '../DashboardMigrants/components/MigrantsFooter'

export const LoginRegister = () => {
  const { dispatch } = useContext(AuthContext)

  //----------- Hooks to save data ------------
  const [passwordView, setPasswordView] = useState(true)
  const [loading, setLoading] = useState(false)

  //------------ Queries and Mutations ------------
  const [authUser] = useMutation(AUTH_USER)
  const [decryptToken] = useMutation(DECRYPT_TOKEN)
  const [getAllUserPermissions] = useMutation(GET_ALL_USER_PERMISSIONS, {
    fetchPolicy: 'no-cache',
  })

  const [registerUser] = useMutation(REGISTER_USE_FROM_LOGIN, {
    refetchQueries: [
      {
        query: GET_USERS,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
    ],
  })

  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    resolver: yupResolver(validationSchemaRegisterUser),
  })

  // --------- UseEffects -----

  //-------- Functions -----------
  const handleSave = async (Data) => {
    setLoading(true)
    try {
      if (Data.password.length !== 6) {
        setLoading(false)
        return toastSweetAlert({
          mode: 'error',
          message: 'La contraseña debe tener 6 caracteres',
        })
      }
      // for (const character of Data.password) {
      //   if (
      //     character !== '0' &&
      //     character !== '1' &&
      //     character !== '2' &&
      //     character !== '3' &&
      //     character !== '4' &&
      //     character !== '5' &&
      //     character !== '6' &&
      //     character !== '7' &&
      //     character !== '8' &&
      //     character !== '9'
      //   ) {
      //     setLoading(false)
      //     return toastSweetAlert({
      //       mode: 'error',
      //       message: 'La contraseña debe contener numeros',
      //     })
      //   }
      // }

      const user = await registerUser({
        variables: {
          input: {
            name: Data.name.trim(),
            email: Data.userEmail.toLowerCase().trim(),
            password: Data.password.trim(),
            phone: String(Data.userPhone).trim(),
            address: Data.address.trim(),
          },
        },
      })
      if (user) {
        const { data: dataToken } = await authUser({
          variables: {
            input: {
              email: Data.userEmail.toLowerCase().trim(),
              password: Data.password.trim(),
            },
          },
        })
        const token = dataToken.authUser.token
        localStorage.setItem('token', token)
        const { data: tokenData } = await decryptToken({
          variables: {
            token,
          },
        })
        const decoded = tokenData.decryptToken
        const { data: userPermissionsData } = await getAllUserPermissions({
          variables: {
            userID: decoded.id,
          },
        })
        const userPermissions = userPermissionsData.getAllUserPermissions
        dispatch({
          type: types.login,
          payload: {
            logged: true,
            idUser: decoded.id,
            type_user: decoded.type_user,
            role: decoded.role,
            email: decoded.email,
            userPermissions,
            avatar: decoded.avatar,
            name: decoded.name,
            first_name: decoded?.first_name,
            last_name: decoded?.last_name,
            phone: decoded.phone,
            jurisdiction_id: decoded.jurisdiction_id,
            sub_jurisdiction_id: decoded.sub_jurisdiction_id,
            provider_id: decoded?.provider_id,
          },
        })
        return (
          setLoading(false),
          toastSweetAlert({
            mode: 'ok',
            message: 'Se ha registrado con éxito',
          })
        )
      } else {
        setLoading(false)
        return toastSweetAlert({
          mode: 'error',
          message: 'Surgio un error, intentelo mas tarde',
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      return toastSweetAlert({
        mode: 'error',
        message: error?.message,
      })
    }
  }

  const handleSeePassword = (id) => {
    var pw = document.getElementById(id)
    if (passwordView) pw.type = 'text'
    else pw.type = 'password'
    return setPasswordView(!passwordView)
  }

  return (
    <div className="login-register-container row">
      <div className="col-12">
        <MigrantsHeader showContact={false} />
      </div>
      {!loading && (
        <div className="full-container login-register col-12">
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(handleSave)}>
              <Box
                title={''}
                btnRedPath="/login"
                btnRedTxt="Cancelar"
                btnSubmitText="Registrarte"
                btnSubmit={true}
                btnState={loading}
                errors={errors}
                content={
                  <>
                    <div className="row text-center">
                      {/* <div className="col-12 image-box">
                        <img src={Logo} className="img-logo-full" alt="logo" />
                      </div> */}
                      <h5 className='title-migrates'>Registro</h5>
                      <span className='text-migrates'>Registrate para continuar</span>
                    </div>
                    <div className="row mt-3">
                      <div className="mb-3 col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6">
                        <InputController
                          label="Nombre"
                          type="text"
                          name="name"
                          id="name"
                          placeholder="Ingrese un nombre"
                          control={control}
                          minLength="5"
                          maxLength="100"
                        />
                      </div>
                      <div className="mb-3 col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6">
                        <InputController
                          label="Correo electrónico"
                          type="text"
                          name="userEmail"
                          placeholder="Ingrese un correo electrónico"
                          control={control}
                          minLength="5"
                          maxLength="50"
                        />
                      </div>
                      <div className="mb-3 col-12 col-xs-12 col-md-12">
                        <InputController
                          label="Teléfono"
                          type="text"
                          name="userPhone"
                          placeholder="Ingrese un teléfono"
                          control={control}
                          minLength="1"
                          maxLength="10"
                          inputMode="numeric"
                          pattern="\d*"
                        />
                      </div>
                      <div className="mb-3 col-12 col-xs-12 col-md-12">
                        <InputController
                          label="Dirección"
                          type="text"
                          name="address"
                          placeholder="Ingrese una dirección"
                          minLength="5"
                          maxLength="200"
                          control={control}
                        />
                      </div>
                      <div className="mb-3 col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6 icon-inside">
                        <InputController
                          label="Contraseña (6 caracteres)"
                          type="password"
                          name="password"
                          placeholder="Contraseña"
                          id="implement-password-view"
                          addClass="implement-password-view"
                          control={control}
                          minLength="6"
                          maxLength="6"
                          // inputMode="numeric"
                          // pattern="\d*"
                        />
                        <i
                          className="far fa-eye"
                          onClick={() =>
                            handleSeePassword('implement-password-view')
                          }
                        ><span> Ver contraseña</span> </i>
                      </div>
                      <div className="mb-3 col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6">
                        <InputController
                          label="Confirmar contraseña"
                          type="password"
                          name="passwordConfirm"
                          placeholder="Contraseña"
                          id="implement-password-view2"
                          addClass="implement-password-view2"
                          control={control}
                          minLength="6"
                          maxLength="6"
                          // inputMode="numeric"
                          // pattern="\d*"
                        />
                      </div>
                    </div>
                  </>
                }
              />
            </form>
          </FormProvider>
        </div>
      )}
      <div className="col-12">
        <MigrantsFooter showContact={false} showChatbot={false} />
      </div>
    </div>
  )
}
